const state = {
  department: 'tutor',
  keyfrom: 'wechat-official',
}
const mutations = {
  setDepartment(state, department) {
    state.department = department
  },
  setKeyfrom(state, keyfrom) {
    state.keyfrom = keyfrom
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
